import { useFormikContext } from "formik";
import React from "react";
import FancyRadioInput from "../../../../../components/form/fancy-radio-input";
import TextInput from "../../../../../components/form/text-input";
import useUserStore from "../../../../../stores/user";
import PinBasedDebit from "../components/pin-based-debit";
import useOrganizationStore from "../../../../../stores/organization";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import styles from "./style.module.scss";

const DualPricing = () => {
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext();
  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  return (
    <>
      <div className={styles.container}>
        <h6>Select preferred dual pricing rate</h6>

        <div className={styles.pricing}>
          <FancyRadioInput
            className={styles.rateButton}
            id="dual_pricing_rate1"
            name="dual_pricing_rate"
            label="3%"
            value={3}
            onChange={handleChange}
            onBlur={handleBlur}
            checked={values.dual_pricing_rate == 3}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          <FancyRadioInput
            className={styles.rateButton}
            id="dual_pricing_rate2"
            name="dual_pricing_rate"
            label="3.25%"
            value={3.25}
            onChange={handleChange}
            onBlur={handleBlur}
            checked={values.dual_pricing_rate == 3.25}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          <FancyRadioInput
            className={styles.rateButton}
            id="dual_pricing_rate3"
            name="dual_pricing_rate"
            label="3.5%"
            value={3.5}
            onChange={handleChange}
            onBlur={handleBlur}
            checked={values.dual_pricing_rate == 3.5}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          <FancyRadioInput
            className={styles.rateButton}
            id="dual_pricing_rate4"
            name="dual_pricing_rate"
            label="3.75%"
            value={3.75}
            onChange={handleChange}
            onBlur={handleBlur}
            checked={values.dual_pricing_rate == 3.75}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          <FancyRadioInput
            className={styles.rateButton}
            id="dual_pricing_rate5"
            name="dual_pricing_rate"
            label="4%"
            value={4}
            onChange={handleChange}
            onBlur={handleBlur}
            checked={values.dual_pricing_rate == 4}
            disabled={nonEditableTemplateOrPricingRestricted}
          />
        </div>
        <span
          style={{
            color: "#f4ba3b",
            fontSize: "12px",
          }}
        >
          {getSoftLimitWarning(
            pricingDefaults?.dual_pricing?.dual_pricing_rate?.soft_limit,
            values.dual_pricing_rate,
            errors.dual_pricing_rate,
          )}
        </span>

        <div className={styles.feeSection}>
          <TextInput
            label={"Transaction Fee"}
            type="text"
            prefix={"$"}
            suffix={"/txn"}
            placeholder={"0.00"}
            id={"dual_pricing_per_transaction"}
            name={"dual_pricing_per_transaction"}
            value={values?.dual_pricing_per_transaction}
            inputMode="decimal"
            onBlur={handleBlur}
            touched={touched?.dual_pricing_per_transaction}
            errored={errors?.dual_pricing_per_transaction}
            error={errors?.dual_pricing_per_transaction}
            hasWarning={getSoftLimitWarning(
              pricingDefaults?.dual_pricing?.dual_pricing_per_transaction
                ?.soft_limit,
              values.dual_pricing_per_transaction,
              errors.dual_pricing_per_transaction,
            )}
            onChange={handleChange}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "dual_pricing_per_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Monthly Fee"}
            type="text"
            prefix={"$"}
            suffix={"/mo"}
            placeholder={"0.00"}
            id={"dual_pricing_monthly_fee"}
            name={"dual_pricing_monthly_fee"}
            value={values?.dual_pricing_monthly_fee}
            inputMode="decimal"
            onBlur={handleBlur}
            touched={touched?.dual_pricing_monthly_fee}
            errored={errors?.dual_pricing_monthly_fee}
            error={errors?.dual_pricing_monthly_fee}
            hasWarning={getSoftLimitWarning(
              pricingDefaults?.dual_pricing?.dual_pricing_monthly_fee
                ?.soft_limit,
              values.dual_pricing_monthly_fee,
              errors.dual_pricing_monthly_fee,
            )}
            onChange={handleChange}
            disabled={nonEditableTemplateOrPricingRestricted}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "dual_pricing_monthly_fee",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>

      {/* <PinBasedDebit pricingModel="dual_pricing" /> */}
    </>
  );
};

export default DualPricing;
